import React from 'react'
import styled from 'styled-components'
import { Box } from './styled'

const Video = styled.video.attrs({
  autoPlay: true,
  playsInline: true,
  muted: true,
  loop: true,
  type: 'video/mp4'
})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  object-fit: cover;
  object-position: ${props => props.objectPosition || 'top'};
  opacity: ${props => props.opacity || 0.99};
  mix-blend-mode: ${props => props.mixBlendMode || 'overlay'};
`

class VideoTile extends React.Component {
  render() {
    const {
      src,
      color,
      height,
      width,
      objectPosition,
      opacity,
      mixBlendMode,
      ...rest
    } = this.props
    return (
      <Box
        position="relative"
        height={height || '100%'}
        bg={color}
        css={{ overflow: 'hidden' }}
        {...rest}
      >
        <Video
          src={src}
          objectPosition={objectPosition}
          opacity={opacity}
          mixBlendMode={mixBlendMode}
          style={{ width: width || '100%', height: '100%' }}
        />
      </Box>
    )
  }
}

export default VideoTile
